import * as firebase from 'firebase/app'
import 'firebase/database'
import Cookies from 'js-cookie'
import {
    USERS_FETCH,
	USER_FETCH_BY_ID,
	USER_ADD_POINT,
	USER_SOCIAL_CHECK,
	USER_POINT_FETCH
} from './types';

// user_id = created_date

export const userPointFetch = () => {
	return (dispatch) => {
		let	pointsRef = firebase.database().ref('points')
		pointsRef.once('value', snapshot => {
			let data = []
			snapshot.forEach(childSnapshot => {
				let item = childSnapshot.val()
				data.push(item)
			})

			data.forEach((item,index) => {
				firebase.database().ref('users').orderByChild('user_id').equalTo(item.userid).once('value', snapshot => {
					if(snapshot.exists()) {
						let item = snapshot.val()
						item = item[Object.keys(item)[0]]
						data[index].name = item.firstname+" "+item.lastname
					}
				})
			})
			setTimeout(()=>dispatch({ type: USER_POINT_FETCH, payload: data.reverse() }),500)
			// dispatch({ type: USER_POINT_FETCH, payload: data.reverse() })
		})
	}
}

export const userVerifyLineCheck = (social_id, social) => {
	return (dispatch) => {
		firebase.database().ref("users").orderByChild(social).equalTo(social_id).once('value', snapshot => {
			if(snapshot.exists()) {
				let item = snapshot.val()
				item = item[Object.keys(item)[0]]
				Cookies.set('user', item)
				window.location = "/"
			} else {
				dispatch({ type: USER_SOCIAL_CHECK, payload: false })
			}
		})
	}
}

export const userVerify = (data, userid, social) => {
	return (dispatch) => {
		firebase.database().ref("users").orderByChild("user_id").equalTo(userid).once('value', snapshot => {
			let item = snapshot.val()
			if(item) {
				item = item[Object.keys(item)[0]]
				firebase.database().ref('users/'+item.id).update({ [social]: data.id, pic: data.pic, status: data.status })
				.then(() => { 
					firebase.database().ref("users").orderByChild(social).equalTo(data.id).once('value', snapshot => {
						let item = snapshot.val()
						item = item[Object.keys(item)[0]]
						Cookies.set('user', item)
						window.location = "/"
					})
				})
			} else {
				window.location = "/login"
			}
			
		})
	}
}

// Update user point
const userPointUpdate = (keyid, mpoint, operation) => {
	if(operation === "delete") {
		firebase.database().ref('users/'+keyid+'/point').once('value', snapshot => { 
			let point = snapshot.val()-mpoint
			firebase.database().ref('users/'+keyid).update({point})
			.then(res => window.location = "/admin")
		})
	} else if(operation === "add") {
		firebase.database().ref('users/'+keyid+'/point').once('value', snapshot => { 
			let point = snapshot.val()+mpoint
			firebase.database().ref('users/'+keyid).update({point})
			.then(res => window.location = "/admin")
		})
	}
}

export const userDelPoint = (keyid, data) => {
	return (dispatch) => {
		const pointRef = firebase.database().ref('points').push()
		const id = pointRef.key
		data.id = id
		pointRef.set(data)
		.then(response => {
			// Update user point
			userPointUpdate(keyid, data.point, "delete")
		})
	}
}

export const userAddPoint = (keyid, data) => {
	return (dispatch) => {
		dispatch({ type: USER_ADD_POINT, payload: false })
		firebase.database().ref("points").orderByChild("invoice").equalTo(data.invoice).once('value', snapshot => {
			if (snapshot.exists()) {
				let chk = false
				snapshot.forEach(childSnap => {
					if (data.type === childSnap.val().type) chk = true
				})

				if(chk) {
					dispatch({ type: USER_ADD_POINT, payload: true })
				} else {
					const pointRef = firebase.database().ref('points').push()
					const id = pointRef.key
					data.id = id
					pointRef.set(data)
					.then(response => {
						// Update user point
						userPointUpdate(keyid, data.point, "add")
					})
					.catch(err => {
						console.log("userAddPointById", err)
					})
				}
				
			} else {
				const pointRef = firebase.database().ref('points').push()
				const id = pointRef.key
				data.id = id
				pointRef.set(data)
				.then(response => {
					// Update user point
					userPointUpdate(keyid, data.point, "add")
				})
				.catch(err => {
					console.log("userAddPointById", err)
				})
			}
		})


		
	}
}

export const userUpdate = (id, user) => {
    return (dispatch) => {
		firebase.database().ref('users/'+id).update(user)
        .then(res => window.location = "/admin")
        .catch(err => console.log(err))
	}
}

export const userFetchById = (id) => {
    return (dispatch) => {
        let	usersRef = firebase.database().ref('users/'+id)
		usersRef.once('value', snapshot => {
			dispatch({ type: USER_FETCH_BY_ID, payload: snapshot.val() })
		})
    }
}

export const usersFetch = () => {
	return (dispatch) => {
		let	usersRef = firebase.database().ref('users')
		usersRef.once('value', snapshot => {
			let data = []
			snapshot.forEach(childSnapshot => {
				let item = childSnapshot.val()
				data.push(item)
			})
			dispatch({ type: USERS_FETCH, payload: data.reverse() });
		})
	}
}

export const userAdd = (user) => {
	return (distpatch) => {
		const usersRef = firebase.database().ref('users').push()
		const id = usersRef.key
		user.id = id
		usersRef.set(user)
		.then(response => {
			window.location = "/admin"
		})
		.catch(err => {
			console.log("userAdd", err)
		})
	}
}

export const userDeleteById = (id) => {
	return (dispatch) => {
			firebase.database().ref('users/'+id).remove()
			.then(() => window.location = "/admin")
	}
}